import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/impactStory/pageContext';

export const ImpactStoryErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for Impact Story page (error: ${error})`);
};
